<template>
  <article class="card mt-2" v-bind:class="{ selected: selected }">
    <div class="card-body">
      <h4 class="card-title">{{ contact.name }}</h4>
      <h6 v-if="contact.organisation" class="card-subtitle text-muted mb-2">
        {{ contact.organisation }}
      </h6>

      <div class="card-text mb-1">
        <p class="m-0 p-0" v-if="contact.description">
          {{ contact.description }}
        </p>
        <p class="m-0 p-0" v-if="contact.address">
          {{ contact.address }}
        </p>
        <p class="m-0 p-0" v-if="contact.postal_code">
          {{ contact.postal_code }}
        </p>
        <p class="m-0 p-0" v-if="contact.city">
          {{ contact.city }}
        </p>
        <p class="m-0 p-0" v-if="contact.email">
          <a class="Xfa-lg" target="_blank" :href="`mailto:${contact.email}`">
            <font-awesome-icon icon="envelope" />
            <span class="ml-1">{{ contact.email }}</span>
          </a>
        </p>
        <p class="m-0 p-0" v-if="contact.phone_number">
          <a class="Xfa-lg" target="_blank" :href="`tel:${contact.phone_number}`">
            <font-awesome-icon icon="phone" />
            <span class="ml-1">{{ contact.phone_number }}</span>
          </a>
        </p>
      </div>

      <a class="mr-3 fa-lg" target="_blank" v-if="contact.website_url" :href="contact.website_url">
        <font-awesome-icon icon="link" />
      </a>
      <a v-if="contact.linkedin_url" :href="contact.linkedin_url"
         class="mr-3 fa-lg" target="_blank">
        <font-awesome-icon :icon="['fab', 'linkedin']" />
      </a>
    </div>
  </article>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'ContactCard',
  components: {
    FontAwesomeIcon,
  },
  props: {
    contact: Object,
    selected: Boolean,
  },
};
</script>
<style lang="scss">
a {
  color: #dc291e;
}
article.selected {
  border-color: rgba(68, 68, 68);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(68, 68, 68, 0.6);
}
</style>
